import type React from 'react';
import styles from './TestHypotheses.module.css';

interface HypothesisDetailModalProps {
  hypothesis: any;
  onClose: () => void;
}

export const HypothesisDetailModal: React.FC<HypothesisDetailModalProps> = ({ hypothesis, onClose }) => {
  return (
    <div className={styles.modal} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{hypothesis.title}</h2>
          <button type="button" className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.modalMeta}>
          <span className={styles.categoryBadge}>{hypothesis.category}</span>
          <span className={styles.severityBadge} data-severity={hypothesis.severity?.toLowerCase()}>
            {hypothesis.severity}
          </span>
        </div>

        <div className={styles.modalSection}>
          <h3 className={styles.modalSectionTitle}>Description</h3>
          <p className={styles.modalText}>{hypothesis.description}</p>
        </div>

        {hypothesis.testSteps && hypothesis.testSteps.length > 0 && (
          <div className={styles.modalSection}>
            <h3 className={styles.modalSectionTitle}>Test Steps</h3>
            <ol className={styles.modalList}>
              {hypothesis.testSteps.map((step: string, idx: number) => (
                <li key={idx}>{step}</li>
              ))}
            </ol>
          </div>
        )}

        {hypothesis.expectedResult && (
          <div className={styles.modalSection}>
            <h3 className={styles.modalSectionTitle}>Expected Result</h3>
            <p className={styles.modalText}>{hypothesis.expectedResult}</p>
          </div>
        )}
      </div>
    </div>
  );
};
